import React from "react";
import {
  Moon,
  RefreshCcw,
  Loader,
  Compass,
  Users,
  Clock,
  Sparkles,
} from "lucide-react";

const ICON_MAP = {
  moon: Moon,
  sleep: Moon,
  refresh: RefreshCcw,
  "refresh-ccw": RefreshCcw,
  loader: Loader,
  loader2: Loader,
  compass: Compass,
  users: Users,
  clock: Clock,
};

const FALLBACK_ICONS = [Moon, Loader, Users, RefreshCcw, Compass, Clock];

/**
 * Section 02 — list of "when you might use it" items. Each item has an icon,
 * a bold lead-in, and trailing description text. Renders 2-column on desktop,
 * 1-column on mobile.
 */
const WhenToUse = ({ section, number = "02" }) => {
  if (!section) return null;
  const {
    title = "When you might use it",
    description,
    items = [],
  } = section;

  if (items.length === 0 && !description) return null;

  return (
    <div className="corp-section-card">
      <div className="flex items-center gap-3">
        <span className="corp-section-num">{number}</span>
        <h2 className="corp-section-title">{title}</h2>
      </div>
      {description && <p className="corp-section-desc">{description}</p>}
      {items.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6 md:gap-y-9">
          {items.map((item, idx) => {
            const Icon =
              (item.icon && ICON_MAP[String(item.icon).toLowerCase()]) ||
              FALLBACK_ICONS[idx % FALLBACK_ICONS.length] ||
              Sparkles;
            return (
              <div key={idx} className="flex items-center gap-4">
                <span className="corp-icon-tile">
                  <Icon size={20} />
                </span>
                <p className="text-sm leading-relaxed text-[#444] m-0">
                  <strong className="font-bold">{item.lead_in}</strong>
                  {item.description ? ` ${item.description}` : null}
                </p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default WhenToUse;
